<template>
  <div v-if="isOpen" class="oap-mikmak-coupon-container" :style="{ top: scrollY }">
    <div class="relative-layer">
      <div v-if="isFormOpen" class="coupon-form-wrapper">
        <iframe src="/mikmakform" title="mikmakform"></iframe>
      </div>
      <button @click="onClickCouponButton">
        <span v-if="!isFormOpen">{{ askFreeCouponLabel }}</span>
        <img :src="iconSrc" :alt="askFreeCouponLabel" />
      </button>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'OapMikMakCoupon',
  props: {
    askFreeCouponLabel: {
      type: String,
      required: false,
      default: 'Ask for your free coupon',
    },
    couponImgSrc: {
      type: String,
      required: false,
      default: '/frontend/static/icons/mikmak-coupon.svg',
    },
    closeImgSrc: {
      type: String,
      required: false,
      default: '/frontend/static/icons/close-white.svg',
    },
  },
  data() {
    return {
      iconSrc: '/frontend/static/icons/mikmak-coupon.svg',
      isOpen: false,
      isFormOpen: false,
      scrollY: '0px',
    };
  },
  mounted() {
    eventBus.on('mikmak-coupun-button:open', () => {
      this.iconSrc = '/frontend/static/icons/mikmak-coupon.svg';
      this.isOpen = true;

      setTimeout(() => {
        this.scrollY = `${window.scrollY}px`;
      }, 1000);

      this.isFormOpen = false;
      this.observeSwavenPopup();
    });
  },
  methods: {
    observeSwavenPopup() {
      let interval;
      interval = setInterval(() => {
        const swnPopupWrapperEl = document.querySelectorAll('div[class*="swn-awe-popin"]');

        if (swnPopupWrapperEl.length) {
          clearInterval(interval);
          const observer = new MutationObserver((event) => {
            for (let mutation of event) {
              const className = mutation.target.className;
              if (className.includes('closed')) this.isOpen = false;
            }
          });

          observer.observe(swnPopupWrapperEl[0], {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false,
          });
        }
      }, 500);
    },
    onClickCouponButton() {
      this.isFormOpen = !this.isFormOpen;
      this.iconSrc = this.isFormOpen ? this.closeImgSrc : this.couponImgSrc;
    },
  },
};
</script>
